import React from "react";
import { TextField, MenuItem, FormLabel, FormControl } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import rightCheck from "../assets/icons/right-check.svg";
import SearchableSelectInput from "./SearchableSelectInput";
import { getIn } from "formik";

const SelectInput = ({ field, formik }) => {
  const useSearchableInput = field?.options?.length > 6;

  const fieldValue = field?.value ?? getIn(formik.values, field?.name);
  const fieldError = getIn(formik.errors, field?.name);
  const fieldTouched = getIn(formik.touched, field?.name);

  return (
    <div>
      {!useSearchableInput ? (
        <FormControl fullWidth>
          {field?.label && (
            <FormLabel
              className="form-label"
              sx={{
                color: "#1c252e",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "22px",
                mb: "6px",
              }}
            >
              {field?.label}
              {field?.required && <span style={{ color: "#d3151a" }}> *</span>}
            </FormLabel>
          )}

          <TextField
            inputProps={{ "aria-label": "Without label" }}
            sx={{
              padding: "0",
              border: "0",
              cursor:
                field?.isDisableField || field?.readonly
                  ? "not-allowed"
                  : "pointer",
              "& .MuiOutlinedInput-root": {
                height: "44px",
                padding: "10px 0px",
                borderRadius: "8px",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                fontSize: "14px",
                backgroundColor: field?.readonly ? "#f9fafb " : "inherit",
                cursor:
                  field?.isDisableField || field?.readonly
                    ? "not-allowed"
                    : "pointer",
                "&.Mui-disabled": {
                  cursor: "not-allowed",
                },
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#ff0000",
                opacity: 1,
              },
              "& .MuiInputBase-input": {
                height: "100%",
                cursor:
                  field?.isDisableField || field?.readonly
                    ? "not-allowed"
                    : "pointer",
              },
              "& .MuiSelect-select": {
                cursor:
                  field?.isDisableField || field?.readonly
                    ? "not-allowed"
                    : "pointer",
              },
              "& .MuiSelect-select span::before": {
                content: `"${field?.placeholder}"`,
                color: "#667085",
                opacity: field?.isDisableField ? 0.4 : 1,
              },
              "& .MuiSelect-icon": {
                cursor:
                  field?.isDisableField || field?.readonly
                    ? "not-allowed"
                    : "pointer",
              },
            }}
            fullWidth
            id={field?.name}
            name={field?.name}
            select
            disabled={field?.isDisableField}
            value={fieldValue || ""}
            onChange={(e) => {
              field?.handleOnChange
                ? field?.handleOnChange(e, field?.index, field?.name, null)
                : formik.handleChange(e);
            }}
            onBlur={formik.handleBlur}
            error={fieldTouched && Boolean(fieldError)}
            helperText={fieldTouched && fieldError}
            variant="outlined"
            InputProps={{ readOnly: field?.readonly }}
            SelectProps={{
              IconComponent: ExpandMoreIcon,
              MenuProps: {
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      backgroundColor: "white",
                      "&.Mui-selected": {
                        backgroundColor: "#d3d3d3 !important",
                      },
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    },
                  },
                },
              },
              placeholder: field?.placeholder,
            }}
          >
            {field?.options?.length ? (
              field?.options.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{ position: "relative", fontSize: "14px" }}
                  className="rightTickMain"
                >
                  {option.name}
                  {field.showIcon === true && fieldValue === option.value && (
                    <div className="rightTick">
                      <img src={rightCheck} alt="" />
                    </div>
                  )}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>Loading...</MenuItem>
            )}
          </TextField>
        </FormControl>
      ) : (
        <SearchableSelectInput field={field} formik={formik} />
      )}
    </div>
  );
};

export default SelectInput;
